var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('div',[_vm._t("default",[_c('span',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert"}},[_c('strong',[_vm._v(_vm._s(_vm.message))])])],{"message":_vm.message})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }